import { getID } from "src/libs/utilities"
import { ALIGN, LANDING_TYPE_CONTENT, WriterType } from "../interfaces"

 

export default function random_content() : any[] {
    return [
         {
          "id": getID( "random-content"),
          "type": LANDING_TYPE_CONTENT.RANDOM_CONTENT,
          "data": [
            {
              "id": getID( "writer"),
              "type": LANDING_TYPE_CONTENT.WRITER,
              "writerType": WriterType.PUSHKIN,
              "horizontal_align": ALIGN.MIDDLE,
              "text": "Когда в тоске самоубийства Народ гостей немецких ждал,</p><p>И дух суровый византийства От русской церкви отлетал,</p><p>Когда приневская столица, Забыв величие своё,</p><p>Как опьяневшая блудница, Не знала, кто берет её, —</p><p>Мне голос был. Он звал утешно, Он говорил: «Иди сюда,</p><p>Оставь свой край глухой и грешный, Оставь Россию навсегда.</p><p>Я кровь от рук твоих отмою, Из сердца выну черный стыд,</p><p>Я новым именем покрою Боль поражений и обид».</p><p>Но равнодушно и спокойно Руками я замкнула слух,</p><p>Чтоб этой речью недостойной Не осквернился скорбный дух.</p><p></p><p>  Анна Ахматова",
              "font": "",
              "text_size": 30,
              "position": {
                "top": 0,
                "left": 0,
                "width": "100%",
                "height": "100%",
                "opacity": 1,
                "scale": 1,
                "rotate": 0,
                "style": {},
                "className": "",
                "data": {}
              },
              "text_align": ALIGN.MIDDLE,
              "isHidden": false,
              "style": {},
              "className": "",
              "containerStyle": {
                "marginTop": 50,
                "marginBottom": 0,
                "marginLeft": 0,
                "marginRight": 0
              }
            },
            {
              "id": getID("writer"),
              "type": LANDING_TYPE_CONTENT.WRITER,
              "writerType": WriterType.PUSHKIN,
              "horizontal_align": ALIGN.MIDDLE,
              "text": "Все переменится вокруг. Отстроится столица.</p><p>Детей разбуженных испуг Вовеки не простится.</p><p>Не сможет позабыться страх, Изборождавший лица.</p><p>Сторицей должен будет враг За это поплатиться.</p><p>Запомнится его обстрел. Сполна зачтется время,</p><p> Когда он делал, что хотел, Как Ирод в Вифлееме.</p><p> Настанет новый, лучший век. Исчезнут очевидцы.</p><p>Мученья маленьких калек Не смогут позабыться.</p><p></p><p>Борис Пастернак",
              "font": "",
              "text_size": 30,
              "position": {
                "top": 0,
                "left": 0,
                "width": "100%",
                "height": "100%",
                "opacity": 1,
                "scale": 1,
                "rotate": 0,
                "style": {},
                "className": "",
                "data": {}
              },
              "text_align": ALIGN.MIDDLE,
              "isHidden": false,
              "style": {},
              "className": "",
              "containerStyle": {
                "marginTop": 50,
                "marginBottom": 0,
                "marginLeft": 0,
                "marginRight": 0
              }
            },
            {
              "type": LANDING_TYPE_CONTENT.WRITER,
              "writerType": WriterType.PUSHKIN,
              "horizontal_align": ALIGN.MIDDLE, 
              "text": "Никого не будет в доме, Кроме сумерек. Один</p><p>Зимний день в сквозном проёме Незадёрнутых гардин.</p><p>Только белых мокрых комьев Быстрый промельк маховой.</p><p>Только крыши, снег и, кроме Крыш и снега, — никого.</p><p>И опять зачертит иней, И опять завертит мной</p><p>Прошлогоднее унынье И дела зимы иной,</p><p>И опять кольнут доныне Неотпущенной виной,</p><p>И окно по крестовине Сдавит голод дровяной.</p><p>Но нежданно по портьере Пробежит вторженья дрожь.</p><p>Тишину шагами меря, Ты, как будущность, войдёшь.</p><p>Ты появишься из двери В чём-то белом, без причуд,</p><p>В чём-то впрямь из тех материй, Из которых хлопья шьют.</p><p></p><p>Борис Пастернак",
              "font": "",
              "text_size": 30,
              "position": {
                "top": 0,
                "left": 0,
                "width": "100%",
                "height": "100%",
                "opacity": 1,
                "scale": 1,
                "rotate": 0,
                "style": {},
                "className": "",
                "data": {}
              },
              "text_align":ALIGN.MIDDLE,
              "isHidden": false,
              "style": {},
              "className": "",
              "containerStyle": {
                "marginTop": 50,
                "marginBottom": 0,
                "marginLeft": 0,
                "marginRight": 0
              }
            },
            {
              "type": LANDING_TYPE_CONTENT.WRITER,
              "writerType": WriterType.PUSHKIN,
              "horizontal_align": ALIGN.MIDDLE,
              "text": "Февраль. Достать чернил и плакать! Писать о феврале навзрыд,</p><p>Пока грохочущая слякоть Весною черною горит.</p><p>Достать пролетку. За шесть гривен, Чрез благовест, чрез клик колес,</p><p>Перенестись туда, где ливень Еще шумней чернил и слез.</p><p>Где, как обугленные груши, С деревьев тысячи грачей</p><p>Сорвутся в лужи и обрушат Сухую грусть на дно очей.</p><p>Под ней проталины чернеют, И ветер криками изрыт,</p><p>И чем случайней, тем вернее Слагаются стихи навзрыд.</p><p></p><p>Борис Пастернак",
              "font": "",
              "text_size": 30,
              "position": {
                "top": 0,
                "left": 0,
                "width": "100%",
                "height": "100%",
                "opacity": 1,
                "scale": 1,
                "rotate": 0,
                "style": {},
                "className": "",
                "data": {}
              },
              "text_align":ALIGN.MIDDLE,
              "isHidden": false,
              "style": {},
              "className": "",
              "containerStyle": {
                "marginTop": 50,
                "marginBottom": 0,
                "marginLeft": 0,
                "marginRight": 0
              }
            },
            {
              "type": LANDING_TYPE_CONTENT.WRITER,
              "writerType": WriterType.PUSHKIN,
              "horizontal_align": ALIGN.MIDDLE,
              "text": `Девушка пела в церковном хоре 
О всех усталых в чужом краю,
О всех кораблях, ушедших в море, 
О всех, забывших радость свою.
Так пел ее голос, летящий в купол, 
И луч сиял на белом плече,
И каждый из мрака смотрел и слушал, 
Как белое платье пело в луче.
И всем казалось, что радость будет, 
Что в тихой заводи все корабли,
Что на чужбине усталые люди 
Светлую жизнь себе обрели.
И голос был сладок, и луч был тонок, 
И только высоко, у царских врат,
Причастный тайнам, — плакал ребенок 
О том, что никто не придет назад.

Александр Блок`,
              "font": "",
              "text_size": 30,
              "position": {
                "top": 0,
                "left": 0,
                "width": "100%",
                "height": "100%",
                "opacity": 1,
                "scale": 1,
                "rotate": 0,
                "style": {},
                "className": "",
                "data": {}
              },
              "text_align":ALIGN.MIDDLE,
              "isHidden": false,
              "style": {},
              "className": "",
              "containerStyle": {
                "marginTop": 50,
                "marginBottom": 0,
                "marginLeft": 0,
                "marginRight": 0
              }
            },
          ],
            "position": {
              "top": 0,
              "left": 0,
              "width": "100%",
              "height": "100%",
              "opacity": 1,
              "scale": 1,
              "rotate": 0,
              "style": {},
              "className": "",
              "data": {}
            },
            "isHidden": false,
            "style": {},
            "className": "", 
            defaultTitle: "Случайный стих"
        }
    ]
}